export { default } from './ModalContent';
//# sourceMappingURL=index.js.map